import { makeStyles } from '@material-ui/core/styles'

const ArticleStyles = makeStyles((theme) => ({
  wrapper: {
    margin: '5.65rem 0',
    background:
      'url(/static/images/placeholders/blog-header.jpg) top center no-repeat',
    backgroundSize: 'auto 100vh',
    position: 'relative',
    [theme.breakpoints.up(1024)]: {
      backgroundSize: 'contain',
    },
    '& > *': {
      position: 'relative',
    },
    '&:before': {
      content: '""',
      display: 'block',
      top: 545,
      width: '100%',
      height: 'calc(100% - 545px)',
      backgroundColor: 'white',
      position: 'absolute',
    },
    '& h1': {
      textAlign: 'center',
      fontSize: 36,
      lineHeight: '48px',
      fontFamily: 'DomainNarrow, serif',
      fontWeight: 600,
      color: 'rgb(0, 36, 63)',
    },
    '&:first-of-type': {
      margin: 0,
      padding: '5.65rem 0 0 0',
    },
  },
  heading: {
    textAlign: 'center',
    '& hr': {
      width: 83,
      height: 2,
      border: 'none',
      backgroundColor: theme.palette.primary.light,
      margin: theme.spacing(1, 'auto'),
    },
  },
  image: {
    maxWidth: 988,
    maxHeight: 556,
    margin: 'auto',
    // '& > img': {
    //   width: '100%',
    //   height: '100%',
    //   display: 'inline-block',
    //   objectFit: 'cover',
    // },
  },
  standfirst: {
    fontWeight: 600,
    color: 'rgb(0, 36, 63)',
    '& p': {
      marginTop: 0,
    },
  },
  createdAt: {
    textAlign: 'right',
    margin: 0,
    color: theme.palette.text.secondary,
    fontSize: 12,
  },
  articleWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.up(1024)]: {
      display: 'flex',
    },
  },
  articleContent: {
    [theme.breakpoints.up(1024)]: {
      margin: '0 40px',
      maxWidth: 700,
    },
  },
  sharing: {
    fontSize: 24,
    color: '#7BCAD2',
    marginBottom: '40px',
    [theme.breakpoints.down(1024)]: {
      position: 'relative',
      top: '-20px',
    },
    '& h5': {
      margin: '0 0 6px 0',
      color: 'rgb(0, 36, 63)',
      fontSize: 12,
      fontFamily: theme.typography.fontFamily,
      fontWeight: 600,
    },
    '& svg': {
      marginRight: '6px',
    },
  },
  articleImages: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: theme.spacing(2, 0),
    '& img': {
      width: '49%',
      [theme.breakpoints.down(1024)]: {
        width: 0,
        flexGrow: 1,
        marginLeft: '10px',
      },
      '&:first-child': {
        [theme.breakpoints.down(1024)]: {
          marginLeft: '0px',
        },
      },
    },
  },
  bodyContent: {
    paddingTop: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.text.primary}`,
    marginBottom: theme.spacing(2),
    '&:after': {
      content: '""',
      display: 'block',
      height: 2,
      backgroundColor: theme.palette.text.primary,
      margin: '2rem 0 5px 0',
    },
    '& > img': {
      display: 'block',
      margin: theme.spacing(2, 0),
      maxWidth: '100%',
    },
    '& blockquote': {
      margin: theme.spacing(1, 0),
      lineHeight: '42px',
      fontSize: 30,
      color: 'rgb(0, 36, 63)',
      fontFamily: 'Domaine, serif',
      textAlign: 'center',
    },
  },
  bodyContentVideo: {
    '& h2': {
      padding: '1rem 0',
      lineHeight: '32px',
      fontSize: 30,
      fontWeight: 500,
      color: 'rgb(0, 36, 63)',
      margin: theme.spacing(2, 0, 1, 0),
      [theme.breakpoints.up(1024)]: {
        padding: '1rem 40px',
      },
    },
  },
  bodyContentText: {
    '& p': {
      lineHeight: '30px',
      color: 'rgb(0, 36, 63)',
      fontWeight: 300,
      fontFamily: theme.typography.fontFamily,
      [theme.breakpoints.up(1024)]: {
        padding: '0 40px',
      },
    },
    '& h2': {
      padding: '1rem 0',
      lineHeight: '32px',
      fontSize: 30,
      fontWeight: 500,
      color: 'rgb(0, 36, 63)',
      margin: theme.spacing(2, 0, 1, 0),
      [theme.breakpoints.up(1024)]: {
        padding: '1rem 40px',
      },
    },
    '& h3': {
      padding: '1rem 0',
      lineHeight: '30px',
      fontSize: 22,
      fontWeight: 500,
      color: 'rgb(0, 36, 63)',
      margin: theme.spacing(2, 0, 1, 0),
      [theme.breakpoints.up(1024)]: {
        padding: '1rem 40px',
      },
    },
  },
  carsouselWrapper: {
    margin: theme.spacing(2, 0),
    '& img': {
      maxHeight: 525,
      objectFit: 'cover',
    },
  },
  advert: {
    margin: '2rem auto',
    display: 'block',
    maxWidth: '100%',
    '& a': {
      display: 'block',
    },
    '& img': {
      width: '100%',
    },
  },
  carouselButton: {
    fontSize: 48,
    lineHeight: 0,
    display: 'block',
    width: 13,
    height: 23,
    padding: 0,
    zIndex: 2,
    cursor: 'pointer',
    color: 'white',
    border: 'none',
    outline: 'none',
    background: 'transparent',
    '& svg': {
      width: 13,
      height: 23,
    },
    '&:hover, &:focus': {
      color: 'white',
      outline: 'none',
      background: 'transparent',
    },
    '&[disabled]': {
      opacity: 0.25,
      cursor: 'default',
    },
  },
  dots: {
    width: '100%',
    padding: 0,
    margin: 0,
    listStyle: 'none',
    textAlign: 'center',
    display: 'none',
    height: 12,
    [theme.breakpoints.up(768)]: {
      display: 'flex',
      flexDirection: 'row',
    },
    '& li': {
      position: 'relative',
      width: 12,
      height: 12,
      margin: '0 8px',
      cursor: 'pointer',
      '& button': {
        opacity: 0,
        width: 12,
        height: 12,
        position: 'absolute',
        left: 0,
        top: 0,
      },
      '&:before': {
        display: 'block',
        content: '""',
        fontSize: 0,
        lineHeight: 0,
        width: 6,
        height: 6,
        cursor: 'pointer',
        color: 'transparent',
        border: '2px solid transparent',
        borderRadius: '50%',
        outline: 'none',
        background: '#ffffff',
        opacity: 1,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
      },
    },
  },
  activeDot: {
    '&:before': {
      border: '2px solid #ffffff !important',
      background: 'transparent !important',
      width: '12px !important',
      height: '12px !important',
    },
  },
}))
export default ArticleStyles
